import React, { Component } from "react";
import { Link } from "react-router-dom";
import withSizes from "react-sizes";
import { Icon } from '../../components';

import style from "./Footer.module.scss";
import { useSelector} from 'react-redux';
import useLocale from '../../hooks/useLocale';
import { normalizeMedia } from '../../api/strapi';

function HookWrapper({
  render
}) {
  return render(loadCompanyProfile(), loadGlossary(), loadFooterImage(), useLocale());
}

function loadGlossary() {
  const { data } = useSelector(state => state.global)
  return (data && data.glossary) || {}
}

function loadCompanyProfile() {
  const { data } = useSelector(state => state.global)
  const settings = data && data.settings
  if (settings) {
    return {
      address: settings.address || '',
      phone: settings.phone || '',
      copyright: settings.copyright || '',
      socialmedia: settings.socialLinks || [],
    }
  }
  return {
    address: 'Mega Boulevard Blok RV 2 No 3B, Tarumajaya Bekasi, Jawa Barat 17214',
    phone: '+62 (021) 94948869',
    copyright: 'Copyright 2021. ALL RIGHTS RESERVED',
    socialmedia: []
  }
}

function loadFooterImage() {
  const { data } = useSelector(state => state.global)
  const media = data && data.settings && normalizeMedia(data.settings.footerImage)
  return (media && media.file_url) || ''
}

class Footer extends Component {

  _renderSocialMedia = (el, index) => {
     let socmed = '';
     if(el.platform === 'facebook'){
       socmed = 'fb';
     }
     if(el.platform === 'instagram'){
       socmed = 'ig';
     }
     if(el.platform === 'twitter'){
       socmed = 'twt';
     }
     if(el.platform === 'youtube'){
       socmed = 'yt';
     }
     if(el.platform === 'linkedin'){
       socmed = 'linkedin';
     }
     if(!socmed || !el.url){
       return null;
     }
			return (
			     <a href={el.url} target="_blank" rel="noopener noreferrer" className={`${style[`footer__socmed--link`]}`} key={index}>
              <Icon type={socmed} className={`${style[`footer__socmed--icon`]}`} />
            </a>
			)
    
  }

  render() {
    const { isMobile } = this.props;

    return (
      <HookWrapper render={ (settings,glossary, footerImage, locale) =>
      <div className={style.footer}>
        <div className={style.footer__container}>
          {!isMobile ? (
            <div className={style.footer__desktop}>
              <div className={`${style[`footer__container--section`]}`}>
                <div className={`${style[`footer__container--logo`]}`}>
                  <img src={footerImage !=''? footerImage : '/assets/logo-vertical.svg'}  alt="footer-logo" className={`${style[`footer--logo`]}`} />
                </div>
                <div className={`${style[`footer__container--link`]}`}>
                  <Link to={`/${locale}/about`} className={style.footer__link}>
                    <span>{ glossary.about || 'About'}</span>
                  </Link>
                  <Link to={`/${locale}/projects`} className={style.footer__link}>
                    <span>{ glossary.projects || 'Projects'}</span>
                  </Link>
                  <Link to={`/${locale}/services`} className={style.footer__link}>
                    <span>{ glossary.services || 'Services'}</span>
                  </Link>
                  <Link to={`/${locale}/our-client`} className={style.footer__link}>
                    <span>{ glossary.clients || 'Our Clients'}</span>
                  </Link>
                  <Link to={`/${locale}/contact`} className={style.footer__link}>
                    <span>{ glossary.contact || 'Contact'}</span>
                  </Link>
                </div>
              </div>
              <div className={`${style[`footer__container--section`]}`}>
                <div className={`${style[`footer__container--address`]}`}>
                  <span>{settings.address}</span>
                  <br />
                  <span>{settings.phone}</span>
                </div>
                <div className={`${style[`footer__socmed`]}`}>
                  <span className={`${style[`footer__socmed--title`]}`}>{glossary.followUs|| 'Follow us:'}</span>
                  <div className={`${style[`footer__socmed--container`]}`}>
                  {settings.socialmedia.map((_el, index) => (
                    <>{this._renderSocialMedia(_el, index)}</>
                  ))}
                  </div>
                </div>
              </div>
              <div className={style.footer__separator} />
              <footer>
                <small className={style.copyright}>{settings.copyright}</small>
              </footer>
            </div>
          ) : (
            <>
              <div className={`${style[`footer__container--logo`]}`}>
                <img src={footerImage !=''? footerImage : '/assets/logo-vertical.svg'} alt="footer-logo" className={`${style[`footer--logo`]}`} />
              </div>
              <div className={`${style[`footer__container--address`]} ${style[`footer__address--mbl`]}`}>
                <span>{settings.address}</span>
                <br />
                <span>{settings.phone}</span>
              </div>
              <div className={`${style[`footer__mbl--link`]}`}>
                <Link to={`/${locale}/about`} className={style.footer__link}>
                  <span>{ glossary.about || 'About'}</span>
                </Link>
                <Link to={`/${locale}/projects`} className={style.footer__link}>
                  <span>{ glossary.projects || 'Projects'}</span>
                </Link>
                <Link to={`/${locale}/services`} className={style.footer__link}>
                  <span>{ glossary.services || 'Services'}</span>
                </Link>
                <Link to={`/${locale}/our-client`} className={style.footer__link}>
                  <span>{ glossary.clients || 'Our Clients'}</span>
                </Link>
                <Link to={`/${locale}/contact`} className={style.footer__link}>
                  <span>{ glossary.contact || 'Contact'}</span>
                </Link>
              </div>
              <div className={`${style[`footer__socmed`]}`}>
                <span className={`${style[`footer__socmed--title`]}`}>{glossary.followUs|| 'Follow us:'}:</span>
                <div className={`${style[`footer__socmed--container`]}`}>
                  {settings.socialmedia.map((_el, index) => (
                    <>{this._renderSocialMedia(_el, index)}</>
                  ))}
                </div>
              </div>
              <div className={style.footer__separator} />
              <footer>
                <small className={style.copyright}>{settings.copyright}</small>
              </footer>
            </>
          )}
        </div>
      </div>
      }/>
    )
  }
}

const mapStateToProps = ({ width }) => ({
  isMobile: width < 768,
})

export default withSizes(mapStateToProps)(Footer);